import request from '@/utils/request';

// 通用下拉框接口 例如类型，来源，用途登
export function getSelectData(name, params, useCache = false) {
    return request({
        url: '/dic/' + name,
        method: 'get',
        name: "xdApi",
        params: { vals: params },
        useCache
    });
}

// 查询多个字典
export function moreDicQuery(type, useCache) {
    return request({
        url: '/dic/moreTypeList/' + type,
        method: 'get',
        name: "xdApi",
        useCache
    });
}

// 获取国家
export function getCountry(params) {
    return request({
        url: '/dic/country',
        method: 'get',
        name: 'xdApi',
        params
    });
}

// 获取省市区
export function getAreaInfo(params) {
    return request({
        url: '/areas/listTree',
        method: 'get',
        name: 'xdApi',
        params
    });
}

// 省市区选择
export function getProvince(params) {
    return request({
        url: '/dic/province',
        method: 'get',
        name: 'xdApi',
        params
    });
}
export function getCity(params) {
    return request({
        url: '/dic/city',
        method: 'get',
        name: 'xdApi',
        params
    });
}
export function getDistinct(params) {
    return request({
        url: '/dic/distinct',
        method: 'get',
        name: 'xdApi',
        params
    });
}

// 媒体类型-根据pid获取媒体类型
export function getMediaType(data) {
    return request({
        url: '/mediumType/listByPid',
        method: 'get',
        name: 'xdApi',
        params: data
    });
}

// 获取媒体类型树形 数据
export function getMediaTypeTree(mtypeId) {
    return request({
        url: '/dic/mediumTypeALL',
        method: 'get',
        name: 'xdApi',
        params: { mtypeId }
    });
}

// 行业树形数据
export function getBusinessTree() {
    return request({
        url: '/industry/listTreeIndustry',
        method: 'get',
        name: 'xdApi'
    });
}

// 第三方行业行业树形数据
export function getThirdIndustryTree() {
    return request({
        url: '/thirdIndustry/listAll',
        method: 'get',
        name: 'xdApi'
    });
}

export function getIndustrySelect(params) {
    return request({
        url: '/channel/brand/getClientIndustryTree',
        method: 'get',
        params
    });
}

// 获取地区
export function selectRegionByIds(params) {
    return request({
        url: '/areas/selectByIds',
        method: 'get',
        name: 'xdApi',
        params
    });
}

// 获取热门媒体
export function hotMedia(params) {
    return request({
        url: '/mediumType/getHotMedia',
        method: 'get',
        name: 'xdApi',
        params,
        useCache: true
    });
}

// 获取线上热门媒体
export function hotOnlineMedia(params) {
    return request({
        url: '/mediumType/getHotMediaOn',
        method: 'get',
        name: 'xdApi',
        params,
        useCache: true
    });
}

// 获取当前服务器时间
export function getNowDate() {
    return request({
        url: '/xcxApi/getNowDate',
        method: 'get'
    });
}

// 获取报修类型
export function mediumRepairType(data) {
    return request({
        url: '/mediumRepair/listByTypeAndMtypeId',
        method: 'get',
        name: 'xdApi',
        params: data
    });
}

// 获取层级（电梯 or 楼层）
export function getDefaultBelong(params) {
    return request({
        url: '/medium/getDefaultBelong',
        method: 'get',
        name: 'xdApi',
        params
    });
}

// 获取地铁路线
export function subwayLine(params) {
    return request({
        url: '/dic/line',
        method: 'get',
        name: 'xdApi',
        params
    });
}

// 地铁站点
export function subwayStation(params) {
    return request({
        url: '/dic/station',
        method: 'get',
        name: 'xdApi',
        params
    });
}

// 地铁站点出入口
export function subwayEntrance(params) {
    return request({
        url: '/dic/entrance',
        method: 'get',
        name: 'xdApi',
        params
    });
}

// 签约主体下拉
export function signingCompanyList(enable = 1) {
    return request({
        url: '/enterprise/listSigningCompany',
        method: 'get',
        params: { enable }
    });
}

// 获取所有城市
export function allCity(params) {
    return request({
        url: '/areas/cityList',
        name: "xdApi",
        method: 'get',
        params
    });
}

// 获取所有城市
export function getHotCity(params) {
    return request({
        url: '/dic/getHotCity',
        name: "xdApi",
        method: 'get',
        params
    });
}

// 热门行业
export function getHotIndustry(params) {
    return request({
        url: '/industry/getHotIndustry',
        name: "xdApi",
        method: 'get',
        params
    });
}

// 检查公司是否启用金蝶
export function checkJDStatus(params) {
    return request({
        url: '/tenant/checkJDStatus',
        name: "xdApi",
        method: 'get',
        params
    });
}

// 检查公司是否启用物业平台
export function isProperty(params) {
    return request({
        url: '/tenant/isProperty',
        // name: "xdApi",
        method: 'get',
        params
    });
}

// 查询预算表全部类目
export function budgetCategoryType(params) {
    return request({
        url: '/dic/getJdType/budgetCategoryType',
        name: "xdApi",
        method: 'get',
        params
    });
}

// 查询预算往来单位类型
export function budgetUnitType(params) {
    return request({
        url: '/dic/getJdType/budgetUnitType',
        name: "xdApi",
        method: 'get',
        params
    });
}

// 查询预算费用项目
export function budgetExpenseItem(params) {
    return request({
        url: '/dic/getJdType/budgetExpenseItem',
        name: "xdApi",
        method: 'get',
        params
    });
}

// 查询预算结算方式
export function budgetClearingForm(params) {
    return request({
        url: '/dic/getJdType/budgetClearingForm',
        name: "xdApi",
        method: 'get',
        params
    });
}

// 查询预算付款用途
export function budgetPaymentPurpose(params) {
    return request({
        url: '/dic/getJdType/budgetPaymentPurpose',
        name: "xdApi",
        method: 'get',
        params
    });
}

// 意向单-智能投放媒体类型
export function getCommonMedia(params) {
    return request({
        url: '/mediumType/getCommonMedia',
        name: "xdApi",
        method: 'get',
        params
    });
}

// 销售-地图导出-媒体类型
export function mediumTypeList(params) {
    return request({
        url: '/csmedium/mediumTypeList',
        method: 'get',
        params
    });
}

// 客服-提交上刊任务-特殊拍照要求
export function listSpecialBelongByMtypeId(params) {
    return request({
        url: '/medium/listSpecialBelongByMtypeId',
        name: "xdApi",
        method: 'get',
        params
    });
}

// 获取百度地图ak (参数  type   1 前端  2后端  3小程序 )
export function mapAk(isChange) {
    return request({
        url: isChange ? '/areas/changeBaiduAk' : '/areas/getBaiduAk',
        name: "xdApi",
        method: 'get',
        params: { type: 1 }
    });
}
